import React, { useState, useContext, useEffect, useRef } from "react";
import { useQuery } from "@apollo/client";
import { BetQLService } from "src/common-services";
import { getGameLeague, PERIODS, useGame } from "src/services/EventService";
import { SubscriptionContext } from "src/services/SubscriptionService";
import { useContainerQuery } from "src/services/UtilService";
import { BEST_LINES_QUERY } from "src/gql/queries";
import { STATES } from "src/constants";
import MobileGameLinesRow from "./MobileGameLinesRow";
import GameLinesRow from "./GameLinesRow";
import GameLineNav from "./GameLineNav";
export interface StateItem {
  value: string | null;
  name: string;
}

const ALL_STATE = {
  value: null,
  name: "All States",
};

export const STATE_LIST: StateItem[] = [
  ALL_STATE,
  ...STATES.reduce((arr: StateItem[], s: StateItem) => {
    s.name = BetQLService.titleCase(s.name);
    if (s.name !== "Other") {
      arr.push(s);
    }
    return arr;
  }, []),
];

const GameLines = ({ slugId }: { slugId: string }) => {
  const { game } = useGame({ slug: slugId });
  const league = game && getGameLeague(game);

  const [lineType, setLineType] = useState(league?.key === "MLB" ? "FGmoneyline" : "combined");
  const { userLocale } = useContext(SubscriptionContext);
  const [stateIndex, setStateIndex] = useState(0);
  const container = useRef(null);

  const { data, loading } = useQuery(BEST_LINES_QUERY, {
    ssr: false,
    fetchPolicy: "cache-and-network",
    errorPolicy: "all",
    variables: {
      slugId,
      period: Object.keys(PERIODS),
      locale: STATE_LIST[stateIndex].value,
    },
  });

  useEffect(() => {
    const initialIndex = Math.max(
      0,
      STATE_LIST.findIndex((c) => c.value === userLocale)
    );
    setStateIndex(initialIndex);
  }, []);

  const books = data?.books ?? [];

  const favLineType = league?.favoriteLine ?? "moneyline";
  const displayLineType = lineType === "combined" ? favLineType : lineType;

  const sizeContainer = useContainerQuery(container, {
    small: 768,
    medium: 1200,
    large: Infinity,
  });

  return (
    <div ref={container} className="games-detail-lines-con">
      <GameLineNav
        setLineType={setLineType}
        setStateIndex={setStateIndex}
        selectedLineType={lineType}
        selectedStateIndex={stateIndex}
        currentSportObj={league}
        size={sizeContainer}
      />

      <GameLinesRow
        lineType={lineType}
        game={game}
        currentSportObj={league}
        books={books}
        loading={loading}
        size={sizeContainer}
      />
      <MobileGameLinesRow
        lineType={displayLineType}
        game={game}
        currentSportObj={league}
        books={books}
        loading={loading}
        size={sizeContainer}
      />
    </div>
  );
};

export default GameLines;
